export const ANDROID_CHANNEL_ID = 'default'

export function startPushMessaging() {
  return undefined
}
